import { render, staticRenderFns } from "./editAgent.vue?vue&type=template&id=608db336&"
import script from "./editAgent.vue?vue&type=script&lang=js&"
export * from "./editAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports